<mat-card class="mat-elevation-z0">
  <mat-card-title>
    <h1 class="m-0">{{title}}</h1>
  </mat-card-title>
  <mat-card-subtitle class="mb-0">{{subTitle}}</mat-card-subtitle>

  <mat-card-content class="px-3 w-100">
    <form (ngSubmit)="onSubmit()"
      *ngIf="!isMessageSent"
      [formGroup]="infosForm"
      class="row flex-column">

      <mat-form-field class="w-100">
        <mat-label>{{ 'COMMON.LABEL.EMAIL' | translate }}</mat-label>
        <input matInput
          type="text"
          formControlName="email" />
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>{{ 'COMMON.LABEL.NAME' | translate }}</mat-label>
        <input matInput
          type="text"
          formControlName="fullName" />
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>{{ 'COMMON.LABEL.PHONE_NUMBER' | translate }}</mat-label>
        <input matInput
          type="text"
          formControlName="phoneNumber" />
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>{{ 'COMMON.LABEL.MESSAGE' | translate }}</mat-label>
        <textarea matInput
          cdkTextareaAutosize
          formControlName="message"></textarea>
      </mat-form-field>

      <mat-checkbox class="w-100"
        formControlName="contactsPolicy">
        {{ 'COMMON.LABEL.CONTACTS_POLICY' | translate}}
        <br>
        <span class="privacy-warning">
          {{ 'COMMON.LABEL.CONTACTS_PRIVACY_I_AGREE' | translate}}
        </span>
      </mat-checkbox>

      <mat-checkbox class="w-100 mt-3"
        formControlName="newsletterSubscription">
        {{ 'COMMON.LABEL.NEWSLETTER_SUBSCRIPTION' | translate}}
        <br>
        <span class="privacy-warning">
          {{ 'COMMON.LABEL.NEWSLETTER_PRIVACY_I_AGREE' | translate}}
        </span>
      </mat-checkbox>

      <button mat-raised-button
        class="mt-3"
        color="accent">{{ctaLabel}}</button>
    </form>

    <h2 *ngIf="isMessageSent"
      class="text-center mt-3">
      {{ 'COMMON.LABEL.MESSAGE_SENT' | translate }}
    </h2>
  </mat-card-content>
</mat-card>